import { render, staticRenderFns } from "./UnsupportedBrowserModal.vue?vue&type=template&id=209ee257"
import script from "./UnsupportedBrowserModal.vue?vue&type=script&lang=js"
export * from "./UnsupportedBrowserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports